// Allowlist a login return URL to INTERNAL RELATIVE PATHS ONLY.
// Rejects external origins, schemes (http:, javascript:, data:), protocol-relative URLs (//host),
// backslashes, control characters and malformed values. Falls back to a safe internal default.
export function safeReturnUrl(raw, fallback = "/account") {
  if (!raw || typeof raw !== "string") return fallback;
  let v = raw.trim();
  // Decode once; reject if decoding fails or reveals an unsafe form.
  try {
    v = decodeURIComponent(v);
  } catch {
    return fallback;
  }
  v = v.trim();
  if (!v.startsWith("/")) return fallback;          // must be an internal absolute path
  if (v.startsWith("//")) return fallback;          // protocol-relative //evil.com
  if (v.includes("\\")) return fallback;            // backslash tricks
  if (v.includes("://")) return fallback;           // embedded scheme
  if (/^\/+\s*[a-z][a-z0-9+.-]*:/i.test(v)) return fallback; // scheme after slashes
  if (/[\u0000-\u001f\u007f]/.test(v)) return fallback;       // control chars
  if (v.length > 512) return fallback;
  return v;
}
